import React, {useState} from 'react';
import {useAppSelector} from '../../hooks';
import {Link} from 'react-router-dom';
import Contacts from '../Contacts';
import Profile from '../account/Profile';
import {Support} from '../../../public/icons';
import styles from '../../styles/Header.module.css';
import logo from '../../../public/i/eDoc.svg';
import {useMediaQuery} from "react-responsive";

function Navbar(props: NavbarProps) {
    return (
        <nav>
            <ul className={styles.navlist}>
                <li>
                    <button
                        type="button"
                        className={styles.icon}
                        onClick={props.onSupportClick}
                    >
                        <Support color="var(--white)" height="27px" width="27px"/>
                    </button>
                </li>
                <li>
                    <button
                        type="button"
                        className={styles.icon}
                        onClick={props.onAccountClick}
                    >
                        <Profile user={props.user} mobile={props.isMobile} arrow={props.accountMenu}/>
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default function Header() {
    const [supportMenu, setSupportMenu] = useState(false);
    const [accountMenu, setAccountMenu] = useState(false);

    const isMobile = useMediaQuery({maxWidth: 992});
    const user = useAppSelector((state) => state.user);
    const username = [user.lastname, user.firstname, user.middlename].filter(
        (el) => el?.length,
    );

    const onSupportClick = () => {
        setAccountMenu(false);
        setSupportMenu(!supportMenu);
    };

    const onAccountClick = () => {
        setSupportMenu(false);
        setAccountMenu(!accountMenu);
    };

    document.addEventListener('click', function (event) {
        const headerPopup = document.getElementById('headerPopup');
        const modalWrapper = document.getElementById('modalWrapper');
        const isClickInsidePopup = headerPopup?.contains(event?.target);
        const isClickInsideModal = modalWrapper?.contains(event?.target);

        if (!isClickInsidePopup && isClickInsideModal) {
            setSupportMenu(false);
            setAccountMenu(false);
        }
    });

    return (
        <header className={`${styles.header} ${styles.line}`}>
            <Link to="/" className={styles.logo} reloadDocument={true}>
                <img src={logo} alt=""/>
            </Link>

            <Navbar
                user={user}
                isMobile={isMobile}
                onSupportClick={onSupportClick}
                onAccountClick={onAccountClick}
                accountMenu={accountMenu}
            />
            {(supportMenu || accountMenu) && (
                <div className={styles.modalWrapper} id="modalWrapper">
                    <div className={styles.headerPopup} id="headerPopup"
                            style={{right: !isMobile && supportMenu ? '170px' : undefined}}>
                        {supportMenu && <Contacts/>}
                        {accountMenu && user && (
                            <>
                                <li className={styles.account_item} key={user.key}>
                                    <button
                                        className={styles.account_btn}
                                        type="button"
                                        disabled={true}
                                    >
                                        <div>
                                            {user.company.code === '' ? (
                                                <>
                                                    <p>
                                                        <span>ІПН:</span> {user.login} <br/>{' '}
                                                    </p>
                                                    <p>
                                                        <span>Фізична особа:</span> {username.join(' ')}
                                                    </p>
                                                </>
                                            ) : (
                                                <>
                                                    {user.code && (
                                                        <p>
                                                            <span>Табельний номер:</span> {user.code}
                                                        </p>
                                                    )}
                                                    <p>
                                                        <span>Співробітник:</span> {username.join(' ')}
                                                    </p>
                                                    <p>
                                                        {user.title && (
                                                            <>
                                                                <span/> {user.title}
                                                                <br/>
                                                            </>
                                                        )}
                                                        <span/> {user.company.title}
                                                    </p>
                                                </>
                                            )}
                                        </div>
                                    </button>
                                </li>
                            </>
                        )}
                    </div>
                </div>
            )}
        </header>
    );
}
